import { CategoryDetailsPageContext } from "@NA/Overrides/Pages/CategoryDetailsPage";
import CustomApplicationState from "@NA/Store/Data/CustomApplicationState/CustomApplicationState";
import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { ProductListPageContext } from "@insite/content-library/Pages/ProductListPage";
import Accordion, { AccordionPresentationProps } from "@insite/mobius/Accordion";
import React, { FC } from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

interface OwnProps extends WidgetProps {
    fields: {
        [fields.hideOnMobile]: boolean;
    };
}

const enum fields {
    hideOnMobile = "hideOnMobile",
}

const mapStateToProps = (state: CustomApplicationState) => ({
    showMobileFilter: state.ADIGlobalData.ADIMobileFilterStore.showMobileFilters,
});

type Props = OwnProps & ReturnType<typeof mapStateToProps>;

export interface ProductListFiltersAccordionStyles {
    accordion?: AccordionPresentationProps;
}

export const filtersAccordionStyles: ProductListFiltersAccordionStyles = {
    accordion: {
        css: css`
            padding-top: 20px;
        `,
    },
};

const styles = filtersAccordionStyles;

const ProductListFiltersAccordion: FC<Props> = ({ id, fields, showMobileFilter }) => {
    if (fields.hideOnMobile && showMobileFilter) {
        return null;
    }

    return (
        <Accordion headingLevel={2} {...styles.accordion}>
            <Zone contentId={id} zoneName="Content" />
        </Accordion>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(ProductListFiltersAccordion),
    definition: {
        group: "Product List",
        displayName: "Filters Accordion",
        allowedContexts: [ProductListPageContext, CategoryDetailsPageContext],
        fieldDefinitions: [
            {
                name: fields.hideOnMobile,
                displayName: "Hide on Mobile",
                editorTemplate: "CheckboxField",
                defaultValue: false,
                fieldType: "General",
            },
        ],
    },
};

export default widgetModule;
